import { Link } from 'react-router-dom';
import { offlineVoiceBoxData } from '@/mocks/mossteams';
import ConsultationForm from '@/components/ConsultationForm';

function OfflineVoiceBoxPage() {
  return (
    <>
      {/* Banner */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img
            src="/images/banner-bg.jpg"
            alt="MossTeams 离线语音盒子"
            className="w-full h-full object-cover object-top opacity-35"
          />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-3xl mx-auto">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium text-white/80 border border-white/25 rounded-full backdrop-blur-sm">
              {offlineVoiceBoxData.banner.tag}
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-4">
              {offlineVoiceBoxData.banner.title}
            </h1>
            <p className="text-lg md:text-2xl text-white/80 font-light">
              {offlineVoiceBoxData.banner.subtitle}
            </p>
            <div className="mt-8 translate-y-16 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={offlineVoiceBoxData.cta.primary.href}
                className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line mr-2"></i>{offlineVoiceBoxData.cta.primary.text}
              </a>
              <Link
                to={offlineVoiceBoxData.cta.secondary.href}
                className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-download-line mr-2"></i>{offlineVoiceBoxData.cta.secondary.text}
              </Link>
              <Link
                to={offlineVoiceBoxData.cta.tertiary.href}
                className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line mr-2"></i>{offlineVoiceBoxData.cta.tertiary.text}
              </Link>
              <a
                href={offlineVoiceBoxData.cta.jd.href}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-line mr-2"></i>{offlineVoiceBoxData.cta.jd.text}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA（已注释，按钮已移入顶部 Banner） */}
      {/* <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">需要离线语音盒子方案？</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">我们的技术团队将为您提供定制化离线部署方案与安全评估</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={offlineVoiceBoxData.cta.primary.href}
              className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line mr-2"></i>{offlineVoiceBoxData.cta.primary.text}
            </a>
            <Link
              to={offlineVoiceBoxData.cta.secondary.href}
              className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-download-line mr-2"></i>{offlineVoiceBoxData.cta.secondary.text}
            </Link>
            <Link
              to={offlineVoiceBoxData.cta.tertiary.href}
              className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line mr-2"></i>{offlineVoiceBoxData.cta.tertiary.text}
            </Link>
            <a
              href={offlineVoiceBoxData.cta.jd.href}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-line mr-2"></i>{offlineVoiceBoxData.cta.jd.text}
            </a>
          </div>
        </div>
      </section> */}

      {/* Overview */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <div>
              <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">
                {offlineVoiceBoxData.overview.title}
              </span>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{offlineVoiceBoxData.overview.content}</p>
            </div>
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/5 rounded-3xl" />
              <img
                src={offlineVoiceBoxData.overview.imageSrc || `https://readdy.ai/api/search-image?query=$%7BofflineVoiceBoxData.overview.imageQuery%7D&width=700&height=500&seq=${offlineVoiceBoxData.overview.imageSeq}&orientation=landscape`}
                alt="产品概述"
                className="relative z-10 w-full rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Scenarios */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{offlineVoiceBoxData.scenarios.title}</h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            {offlineVoiceBoxData.scenarios.items.map((s, idx) => (
              <div key={idx} className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
                <div className="h-48 md:h-56 overflow-hidden">
                  <img
                    src={s.imageSrc}
                    alt={s.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                      <i className={`${s.icon} text-base`}></i>
                    </div>
                    <h4 className="text-sm font-bold text-foreground-900">{s.name}</h4>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed pl-12">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">功能详解</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{offlineVoiceBoxData.features.title}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {offlineVoiceBoxData.features.items.map((f, idx) => (
              <div key={idx} className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300">
                <div className="h-40 md:h-48 overflow-hidden">
                  <img
                    src={f.imageSrc}
                    alt={f.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                    <i className={`${f.icon} text-base`}></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900 mb-2">{f.name}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">产品亮点</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3">{offlineVoiceBoxData.advantages.title}</h2>
            <p className="text-sm md:text-base text-foreground-500">{offlineVoiceBoxData.advantages.subtitle}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 max-w-2xl mx-auto">
            {offlineVoiceBoxData.advantages.items.map((a, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-white rounded-xl p-5 md:p-6 border border-background-200">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500">
                  <i className={`${a.icon} text-lg`}></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-foreground-900 mb-1.5">{a.name}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{a.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specs */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{offlineVoiceBoxData.specs.title}</h2>
          </div>
          <div className="bg-white rounded-2xl border border-background-200 overflow-hidden">
            <div className="divide-y divide-background-100">
              {offlineVoiceBoxData.specs.rows.map((row, idx) => (
                <div key={idx} className={`flex flex-col sm:flex-row py-4 px-6 md:px-8 ${idx % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                  <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider w-full sm:w-40 flex-shrink-0 mb-1 sm:mb-0">{row.label}</span>
                  <span className="text-sm text-foreground-800">{row.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{offlineVoiceBoxData.related.title}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {offlineVoiceBoxData.related.items.map((r, idx) => (
              <Link
                key={idx}
                to={r.href}
                className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={r.imageSrc || `https://readdy.ai/api/search-image?query=$%7Br.imageQuery%7D&width=500&height=350&seq=${r.imageSeq}&orientation=landscape`}
                    alt={r.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h4 className="text-sm font-bold text-foreground-900 mb-1">{r.name}</h4>
                  <p className="text-xs text-foreground-500">{r.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Consultation Form */}
      <ConsultationForm badge="商务咨询" title="在线咨询" subtitle="填写以下信息，我们的商务团队将在24小时内与您联系" />
    </>
  );
}

export default OfflineVoiceBoxPage;